{
  "de": {
    "issue_category": {
      "labels": {
        "backup_category": "Ersatzkategorie",
        "category_name": "Kategoriename",
        "delete_category": "Kategorie „{name}“ löschen?",
        "delete_category_disclaimer": "Alle Nachbetreuungspunkte mit dieser Kategorie werden der unten ausgewählten Kategorie zugewiesen.",
        "integration_warning": "Eine Integration mit dem Nachbetreuungsmodul Ihrer Plattform ist aktiv. Wenn Sie Kategorien erstellen oder bearbeiten möchten, kontaktieren Sie uns bitte.",
        "new_category": "Kategorie"
      }
    }
  }
}
